var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 86,
    viewBox: "0 0 144 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 42.4938H7C4.23858 42.4938 2 44.7324 2 47.4938V79C2 81.7614 4.23857 84 7 84H137C139.761 84 142 81.7614 142 79V47.4938C142 44.7324 139.761 42.4938 137 42.4938H100C97.2386 42.4938 95 40.2552 95 37.4938V7C95 4.23858 92.7614 2 90 2H52.5C49.7386 2 47.5 4.23858 47.5 7.00001V37.4938C47.5 40.2552 45.2614 42.4938 42.5 42.4938Z",
    fill: "#AFDB28",
    fillOpacity: 0.2,
    stroke: "#22A156",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5303 8.46967C82.2374 8.17678 81.7626 8.17678 81.4697 8.46967L76.6967 13.2426C76.4038 13.5355 76.4038 14.0104 76.6967 14.3033C76.9896 14.5962 77.4645 14.5962 77.7574 14.3033L82 10.0607L86.2426 14.3033C86.5355 14.5962 87.0104 14.5962 87.3033 14.3033C87.5962 14.0104 87.5962 13.5355 87.3033 13.2426L82.5303 8.46967ZM81.4697 36.5303C81.7626 36.8232 82.2374 36.8232 82.5303 36.5303L87.3033 31.7574C87.5962 31.4645 87.5962 30.9896 87.3033 30.6967C87.0104 30.4038 86.5355 30.4038 86.2426 30.6967L82 34.9393L77.7574 30.6967C77.4645 30.4038 76.9896 30.4038 76.6967 30.6967C76.4038 30.9896 76.4038 31.4645 76.6967 31.7574L81.4697 36.5303ZM81.25 9L81.25 36L82.75 36L82.75 9L81.25 9Z",
    fill: "#22A156"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8636 29.5H57.9347V14.9545H62.9631C64.4072 14.9545 65.6477 15.2457 66.6847 15.8281C67.7263 16.4058 68.5265 17.2367 69.0852 18.321C69.6439 19.4053 69.9233 20.7027 69.9233 22.2131C69.9233 23.7282 69.6416 25.0303 69.0781 26.1193C68.5194 27.2083 67.7121 28.044 66.6562 28.6264C65.6051 29.2088 64.3409 29.5 62.8636 29.5ZM60.5696 27.2202H62.7358C63.7491 27.2202 64.5942 27.0355 65.2713 26.6662C65.9484 26.2921 66.4574 25.7358 66.7983 24.9972C67.1392 24.2538 67.3097 23.3258 67.3097 22.2131C67.3097 21.1004 67.1392 20.1771 66.7983 19.4432C66.4574 18.7045 65.9531 18.1529 65.2855 17.7884C64.6226 17.419 63.7988 17.2344 62.8139 17.2344H60.5696V27.2202Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTd);
export default __webpack_public_path__ + "static/media/td.8dbec4edf97359563fe232e472b6981b.svg";
export { ForwardRef as ReactComponent };